// extracted by mini-css-extract-plugin
export default {"button":"styles_button__HbV1z","arrowIcon":"styles_arrowIcon__2tm3V","arrowIconRight":"styles_arrowIconRight__VbGAf","arrowIconLeft":"styles_arrowIconLeft__RVvdv"};